/**
 * 供应商模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const vendor = {
    //得到指定临时token人员的基本信息
    info(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/vendor/info`, { params: params});
    }
}

export default vendor;



// WEBPACK FOOTER //
// ./src/api/vendor.js